
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { TradingProductSource } from '@/Sources';
  import { ITradingProduct } from '../../Interfaces';

  @Component({
    name: 'trading-product-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class TradingProductDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'CUSIP' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;

    public source: TradingProductSource = new TradingProductSource()

    public innerValue: ITradingProduct | null = null;

    public get val(): ITradingProduct | null { return this.innerValue; }
    public set val(value: ITradingProduct | null) {
      this.$emit('trading-product', value);
      this.innerValue = value;
    }
  }
